import * as d3 from 'd3';
import { primaryColor } from 'styles/colors';

export const defaultColorScale = max =>
	d3
		.scaleLinear()
		.domain([0, max])
		.range(['#FFFFFF', primaryColor]);

export const formatDataAsMap = data => {
	try {
		let map = {};
		data.entries.forEach(value => {
			map[value.key] = { value: value.count };
		});
		return map;
	} catch {
		return {};
	}
};

export function removeFractionalTicks(ticks) {
	if (ticks[ticks.length - 1] <= 1) {
		return [0, 1];
	} else if (ticks[ticks.length - 1] <= 2) {
		return [0, 1, 2];
	}
	return ticks;
}
